import React from "react";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../contexts/AuthContext";

type Props = {
  children: React.ReactNode;
};

const ProtectedRoute: React.FC<Props> = ({ children }) => {
  const { token, loading } = useContext(UserContext);
  console.log("token", token);
  if (loading) {
    return <p>Loading</p>;
  }
  return token ? <>{children}</> : <Navigate to="/" />;
};
export default ProtectedRoute;
